module.exports = "mat-form-field{width:calc(100% - 20px)}.title mat-icon{position:relative;top:5px;color:red}mat-spinner{margin:auto}\n"